import React, { useEffect, useRef, useState } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import DateRangeIcon from '@material-ui/icons/DateRange';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import { api, getListAPI, getListAllAPI } from '../../../services';
import { PRIMARY_COLOR } from '../../../utils';
import {
  DialogoDetalhes,
  corStatus,
  rotuloStatus,
} from '../../Documentos/List';

const POR_PAGINA = 10;

// Cabeçalho colorido, como nas tabelas das telas do gerencial.
const cabecalhoTabela = {
  backgroundColor: PRIMARY_COLOR,
  color: 'white',
  fontWeight: 500,
};
const FILTROS_VAZIOS = { status: '', modelo: '', de: '', ate: '' };

const COR_PACOTE = {
  pendente: { cor: '#8a4600', fundo: '#fff4e5' },
  processando: { cor: '#01579b', fundo: '#e5f6fd' },
  pronto: { cor: '#1b5e20', fundo: '#e8f5e9' },
  erro: { cor: '#b71c1c', fundo: '#ffebee' },
};

const rotuloPacote = (pacote) =>
  ({
    pendente: 'Na fila',
    processando: `Gerando ${pacote.processados} de ${pacote.total_documentos}`,
    pronto: 'Pronto',
    erro: 'Erro',
  }[pacote.status] || pacote.status);

const dia = (data) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(
    data.getDate(),
  )}`;
};

const formatarDia = (valor) => valor.split('-').reverse().join('/');

const textoPeriodo = (de, ate) => {
  if (de && ate) return `${formatarDia(de)} a ${formatarDia(ate)}`;
  if (de) return `A partir de ${formatarDia(de)}`;
  if (ate) return `Até ${formatarDia(ate)}`;
  return '';
};

// Atalhos de período, calculados a partir de hoje.
const atalhosPeriodo = () => {
  const hoje = new Date();
  const dias30 = new Date();
  dias30.setDate(hoje.getDate() - 30);
  return [
    { rotulo: 'Últimos 30 dias', de: dia(dias30), ate: dia(hoje) },
    {
      rotulo: 'Este mês',
      de: dia(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
      ate: dia(hoje),
    },
    {
      rotulo: 'Este ano',
      de: dia(new Date(hoje.getFullYear(), 0, 1)),
      ate: dia(hoje),
    },
  ];
};

const STATUS = [
  { id: 'pendente', nome: 'Aguardando' },
  { id: 'assinado', nome: 'Assinado' },
  { id: 'em_analise', nome: 'Em análise' },
  { id: 'enviado', nome: 'Arquivo enviado' },
  { id: 'rejeitado', nome: 'Rejeitado' },
  { id: 'emitido', nome: 'Só leitura' },
  { id: 'lido', nome: 'Lido' },
  { id: 'cancelado', nome: 'Cancelado' },
];

const textoAcao = {
  assinar: 'Assinar',
  visualizar: 'Visualizar',
  enviar_arquivo: 'Enviar arquivo',
};

// Documentos do colaborador, com filtros e paginação de 10 no servidor. Os dados
// vêm da lista de Documentos, que exige a permissão da tela Documentos.
const DocumentosColaborador = ({ colaboradorId, nomeColaborador }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [filtros, setFiltros] = useState(FILTROS_VAZIOS);
  const [pagina, setPagina] = useState(0);
  const [dados, setDados] = useState({ data: [], total: 0 });
  const [modelos, setModelos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [semPermissao, setSemPermissao] = useState(false);
  const [detalhes, setDetalhes] = useState(null);
  const [ancoraPeriodo, setAncoraPeriodo] = useState(null);
  const [pacotes, setPacotes] = useState([]);
  const [gerando, setGerando] = useState(false);
  const [visto, setVisto] = useState(null);
  const [ancoraPdfs, setAncoraPdfs] = useState(null);
  const statusAnteriores = useRef({});
  const [rascunho, setRascunho] = useState({ de: '', ate: '' });

  useEffect(() => {
    getListAllAPI('modelos_documentos', ['nome', 'asc'], {}, [])
      .then(({ data }) => setModelos(Array.isArray(data) ? data : []))
      .catch(() => setModelos([]));
  }, []);

  useEffect(() => {
    let ativo = true;
    setCarregando(true);
    const filtro = { colaborador_id: colaboradorId };
    if (filtros.status) filtro.status = filtros.status;
    if (filtros.modelo) filtro.modelo_documento_id = filtros.modelo;
    if (filtros.de) filtro.criado_de = filtros.de;
    if (filtros.ate) filtro.criado_ate = filtros.ate;
    getListAPI(
      'documentos',
      ['created_at', 'desc'],
      [pagina + 1, POR_PAGINA],
      filtro,
      [],
    )
      .then((resposta) => ativo && setDados(resposta))
      .catch((e) => {
        if (!ativo) return;
        if (e.response && e.response.status === 403) setSemPermissao(true);
        else {
          enqueueSnackbar('Erro ao carregar os documentos do colaborador.', {
            variant: 'error',
          });
        }
      })
      .finally(() => ativo && setCarregando(false));
    return () => {
      ativo = false;
    };
  }, [colaboradorId, filtros, pagina]);

  async function carregarPacotes() {
    try {
      const response = await api.get('/documentos/pacotes', {
        params: { colaborador_id: colaboradorId },
      });
      const lista = response.data.data;
      // Avisa quando um pacote que estava em andamento fica pronto.
      lista.forEach((pacote) => {
        const antes = statusAnteriores.current[pacote.id];
        if (
          pacote.status === 'pronto' &&
          (antes === 'pendente' || antes === 'processando')
        ) {
          enqueueSnackbar('O PDF único está pronto para baixar.', {
            variant: 'success',
          });
        }
        statusAnteriores.current[pacote.id] = pacote.status;
      });
      setPacotes(lista);
    } catch (e) {
      // sem permissão ou sem rede: a lista de pacotes só não aparece
    }
  }

  useEffect(() => {
    carregarPacotes();
  }, [colaboradorId]);

  // Enquanto houver pacote na fila ou sendo gerado, consulta de 3 em 3 segundos.
  const emAndamento = pacotes.some(
    (pacote) => pacote.status === 'pendente' || pacote.status === 'processando',
  );
  useEffect(() => {
    if (!emAndamento) return undefined;
    const intervalo = setInterval(carregarPacotes, 3000);
    return () => clearInterval(intervalo);
  }, [emAndamento, colaboradorId]);

  async function gerarPacote() {
    setGerando(true);
    try {
      const filtro = {};
      if (filtros.status) filtro.status = filtros.status;
      if (filtros.modelo) filtro.modelo_documento_id = filtros.modelo;
      if (filtros.de) filtro.criado_de = filtros.de;
      if (filtros.ate) filtro.criado_ate = filtros.ate;
      const response = await api.post('/documentos/pacotes', {
        colaborador_id: colaboradorId,
        filtro,
      });
      enqueueSnackbar(
        `${response.data.message} Você pode continuar usando o sistema: avisamos quando o PDF estiver pronto.`,
        { variant: 'info' },
      );
      await carregarPacotes();
    } catch (e) {
      enqueueSnackbar(
        (e.response && e.response.data && e.response.data.message) ||
          'Não foi possível gerar o PDF único.',
        { variant: 'error' },
      );
    } finally {
      setGerando(false);
    }
  }

  async function obterArquivoPacote(pacote) {
    const response = await api.get(`/documentos/pacotes/${pacote.id}/arquivo`, {
      responseType: 'blob',
    });
    return new Blob([response.data], { type: 'application/pdf' });
  }

  async function baixarPacote(pacote) {
    try {
      const url = URL.createObjectURL(await obterArquivoPacote(pacote));
      const link = document.createElement('a');
      link.href = url;
      link.download = `Documentos - ${nomeColaborador || colaboradorId}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      enqueueSnackbar('Não foi possível baixar o PDF. Ele pode ter expirado.', {
        variant: 'error',
      });
    }
  }

  async function visualizarPacote(pacote) {
    try {
      setVisto({
        pacote,
        url: URL.createObjectURL(await obterArquivoPacote(pacote)),
      });
    } catch (e) {
      enqueueSnackbar('Não foi possível abrir o PDF. Ele pode ter expirado.', {
        variant: 'error',
      });
    }
  }

  async function excluirPacote(pacote) {
    try {
      await api.delete(`/documentos/pacotes/${pacote.id}`);
      enqueueSnackbar('PDF excluído.', { variant: 'success' });
      await carregarPacotes();
    } catch (e) {
      enqueueSnackbar(
        (e.response && e.response.data && e.response.data.message) ||
          'Não foi possível excluir o PDF.',
        { variant: 'error' },
      );
    }
  }

  function fecharVisto() {
    if (visto) URL.revokeObjectURL(visto.url);
    setVisto(null);
  }

  function abrirPeriodo(e) {
    setRascunho({ de: filtros.de, ate: filtros.ate });
    setAncoraPeriodo(e.currentTarget);
  }

  // O servidor aceita um dos limites sozinho; "de" nunca passa de "até".
  function aplicarPeriodo() {
    const { de, ate } = rascunho;
    setPagina(0);
    setFiltros({
      ...filtros,
      de: de && ate && de > ate ? ate : de,
      ate,
    });
    setAncoraPeriodo(null);
  }

  function mudarFiltro(campo, valor) {
    setPagina(0);
    setFiltros({ ...filtros, [campo]: valor });
  }

  // Abre o PDF numa nova aba do navegador.
  async function abrirPdf(documento, rota) {
    try {
      const response = await api.get(`/documentos/${documento.id}/${rota}`, {
        responseType: 'blob',
      });
      window.open(
        URL.createObjectURL(
          new Blob([response.data], { type: 'application/pdf' }),
        ),
        '_blank',
      );
    } catch (e) {
      enqueueSnackbar('Erro ao abrir o PDF.', { variant: 'error' });
    }
  }

  if (semPermissao) {
    return (
      <Typography variant="body2" color="textSecondary">
        Você não tem permissão para ver os documentos dos colaboradores.
      </Typography>
    );
  }

  const temFiltro = Object.values(filtros).some(Boolean);

  return (
    <>
      <Box
        display="grid"
        style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
          gap: 12,
          marginBottom: 16,
        }}
      >
        <TextField
          select
          size="small"
          variant="outlined"
          label="Status"
          value={filtros.status}
          onChange={(e) => mudarFiltro('status', e.target.value)}
          SelectProps={{ native: true }}
          InputLabelProps={{ shrink: true }}
        >
          <option value="">Todos</option>
          {STATUS.map((item) => (
            <option key={item.id} value={item.id}>
              {item.nome}
            </option>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          variant="outlined"
          label="Documento"
          value={filtros.modelo}
          onChange={(e) => mudarFiltro('modelo', e.target.value)}
          SelectProps={{ native: true }}
          InputLabelProps={{ shrink: true }}
        >
          <option value="">Todos</option>
          {modelos.map((modelo) => (
            <option key={modelo.id} value={modelo.id}>
              {modelo.nome}
            </option>
          ))}
        </TextField>
        <TextField
          size="small"
          variant="outlined"
          label="Período de criação"
          placeholder="Qualquer data"
          value={textoPeriodo(filtros.de, filtros.ate)}
          onClick={abrirPeriodo}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            readOnly: true,
            style: { cursor: 'pointer' },
            startAdornment: (
              <InputAdornment position="start">
                <DateRangeIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <Popover
          open={Boolean(ancoraPeriodo)}
          anchorEl={ancoraPeriodo}
          onClose={() => setAncoraPeriodo(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Box p={2} style={{ width: 300 }}>
            <Box display="flex" flexWrap="wrap" style={{ gap: 6 }} mb={2}>
              {atalhosPeriodo().map((atalho) => (
                <Chip
                  key={atalho.rotulo}
                  size="small"
                  variant="outlined"
                  label={atalho.rotulo}
                  clickable
                  onClick={() =>
                    setRascunho({ de: atalho.de, ate: atalho.ate })
                  }
                />
              ))}
            </Box>
            <Box display="flex" style={{ gap: 12 }}>
              <TextField
                type="date"
                size="small"
                variant="outlined"
                label="De"
                value={rascunho.de}
                onChange={(e) =>
                  setRascunho({ ...rascunho, de: e.target.value })
                }
                inputProps={{ max: rascunho.ate || undefined }}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                type="date"
                size="small"
                variant="outlined"
                label="Até"
                value={rascunho.ate}
                onChange={(e) =>
                  setRascunho({ ...rascunho, ate: e.target.value })
                }
                inputProps={{ min: rascunho.de || undefined }}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
            <Box display="flex" justifyContent="space-between" mt={2}>
              <Button
                size="small"
                onClick={() => {
                  setRascunho({ de: '', ate: '' });
                }}
              >
                Limpar
              </Button>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={aplicarPeriodo}
              >
                Aplicar
              </Button>
            </Box>
          </Box>
        </Popover>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        mb={1}
        style={{ gap: 8 }}
      >
        <Button
          size="small"
          color="primary"
          variant="outlined"
          startIcon={<PictureAsPdfIcon />}
          disabled={gerando || dados.total === 0}
          onClick={gerarPacote}
        >
          {gerando
            ? 'Enviando pedido...'
            : `Gerar PDF único (${dados.total || 0})`}
        </Button>
        {pacotes.length > 0 && (
          <Button
            size="small"
            startIcon={
              emAndamento ? (
                <CircularProgress size={14} />
              ) : (
                <PictureAsPdfIcon />
              )
            }
            onClick={(e) => setAncoraPdfs(e.currentTarget)}
          >
            {`PDFs gerados (${pacotes.length})`}
          </Button>
        )}
        {temFiltro && (
          <Chip
            size="small"
            label="Limpar filtros"
            clickable
            onClick={() => {
              setPagina(0);
              setFiltros(FILTROS_VAZIOS);
            }}
          />
        )}
      </Box>

      <Popover
        open={Boolean(ancoraPdfs)}
        anchorEl={ancoraPdfs}
        onClose={() => setAncoraPdfs(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box
          width={560}
          maxWidth="100%"
          maxHeight={420}
          style={{ overflowY: 'auto' }}
        >
          <Box px={2} py={1} bgcolor="action.hover">
            <Typography
              variant="overline"
              color="textSecondary"
              style={{ fontWeight: 700, letterSpacing: 1 }}
            >
              PDFs gerados
            </Typography>
          </Box>
          {pacotes.map((pacote) => (
            <Box
              key={pacote.id}
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              px={2}
              py={1.5}
              style={{ gap: 12, borderTop: '1px solid #eee' }}
            >
              <Box flex="1 1 220px" minWidth={0}>
                <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                  <Chip
                    size="small"
                    label={rotuloPacote(pacote)}
                    style={{
                      backgroundColor: COR_PACOTE[pacote.status].fundo,
                      color: COR_PACOTE[pacote.status].cor,
                      fontWeight: 600,
                    }}
                  />
                  <Typography variant="body2">
                    {pacote.total_documentos} documento(s)
                    {pacote.bytes
                      ? ` · ${(pacote.bytes / 1024 / 1024).toFixed(1)} MB`
                      : ''}
                  </Typography>
                </Box>
                {(pacote.status === 'pendente' ||
                  pacote.status === 'processando') && (
                  <LinearProgress
                    variant={
                      pacote.status === 'pendente'
                        ? 'indeterminate'
                        : 'determinate'
                    }
                    value={
                      pacote.total_documentos
                        ? (pacote.processados / pacote.total_documentos) * 100
                        : 0
                    }
                    style={{ marginTop: 8, borderRadius: 3 }}
                  />
                )}
                <Typography variant="caption" color="textSecondary">
                  {`Pedido em ${new Date(pacote.created_at).toLocaleString(
                    'pt-BR',
                  )}`}
                  {pacote.status === 'pronto' && pacote.expira_em
                    ? ` · disponível até ${new Date(
                        pacote.expira_em,
                      ).toLocaleDateString('pt-BR')}`
                    : ''}
                  {pacote.status === 'erro' && pacote.erro
                    ? ` · ${pacote.erro}`
                    : ''}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                {pacote.status === 'pronto' && (
                  <>
                    <Button
                      size="small"
                      color="primary"
                      startIcon={<VisibilityIcon />}
                      onClick={() => visualizarPacote(pacote)}
                    >
                      Visualizar
                    </Button>
                    <Button
                      size="small"
                      color="primary"
                      variant="contained"
                      startIcon={<GetAppIcon />}
                      onClick={() => baixarPacote(pacote)}
                    >
                      Baixar
                    </Button>
                  </>
                )}
                {pacote.status !== 'processando' && (
                  <Tooltip title="Excluir este PDF">
                    <IconButton
                      size="small"
                      onClick={() => excluirPacote(pacote)}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Popover>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={cabecalhoTabela}>Documento</TableCell>
              <TableCell style={cabecalhoTabela}>Ação</TableCell>
              <TableCell style={cabecalhoTabela}>Status</TableCell>
              <TableCell style={cabecalhoTabela}>Criado em</TableCell>
              <TableCell align="right" style={cabecalhoTabela}>
                Detalhes
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dados.data.map((documento) => (
              <TableRow key={documento.id} hover>
                <TableCell>
                  {documento.modelo ? documento.modelo.nome : '—'}
                </TableCell>
                <TableCell>
                  {(documento.modelo && textoAcao[documento.modelo.acao]) ||
                    '—'}
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={rotuloStatus(documento)}
                    style={{
                      backgroundColor: corStatus[documento.status] || '#9e9e9e',
                      color: 'white',
                    }}
                  />
                </TableCell>
                <TableCell>
                  {new Date(documento.created_at).toLocaleDateString('pt-BR')}
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Detalhes">
                    <IconButton
                      size="small"
                      onClick={() => setDetalhes(documento)}
                    >
                      <InfoOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {!carregando && dados.data.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="textSecondary">
                    {temFiltro
                      ? 'Nenhum documento com esses filtros.'
                      : 'Este colaborador não tem documentos.'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {carregando && dados.data.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body2" color="textSecondary">
                    Carregando...
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={dados.total || 0}
          page={pagina}
          onChangePage={(event, nova) => setPagina(nova)}
          rowsPerPage={POR_PAGINA}
          rowsPerPageOptions={[POR_PAGINA]}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </TableContainer>

      <Dialog open={Boolean(visto)} onClose={fecharVisto} fullScreen>
        <Box
          display="flex"
          alignItems="center"
          px={2}
          py={1}
          style={{ gap: 12, backgroundColor: PRIMARY_COLOR, color: 'white' }}
        >
          <Box minWidth={0}>
            <Typography variant="subtitle1" noWrap style={{ fontWeight: 600 }}>
              {`Documentos - ${nomeColaborador || colaboradorId}`}
            </Typography>
            {visto && (
              <Typography variant="caption" display="block" noWrap>
                {`${
                  visto.pacote.total_documentos
                } documento(s) · pedido em ${new Date(
                  visto.pacote.created_at,
                ).toLocaleString('pt-BR')}`}
              </Typography>
            )}
          </Box>
          <Box flex={1} />
          <Tooltip title="Baixar PDF">
            <IconButton
              size="small"
              style={{ color: 'white' }}
              onClick={() => visto && baixarPacote(visto.pacote)}
            >
              <GetAppIcon />
            </IconButton>
          </Tooltip>
          <IconButton
            size="small"
            style={{ color: 'white' }}
            onClick={fecharVisto}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent style={{ padding: 0, display: 'flex' }}>
          {visto && (
            <iframe
              title="PDF único"
              src={`${visto.url}#toolbar=0&navpanes=0`}
              style={{ border: 0, width: '100%', flex: 1 }}
            />
          )}
        </DialogContent>
      </Dialog>

      <DialogoDetalhes
        documento={detalhes}
        onClose={() => setDetalhes(null)}
        onVisualizarPdf={(documento) => abrirPdf(documento, 'pdf')}
        onVisualizarArquivo={(documento) =>
          abrirPdf(documento, 'arquivo-enviado')
        }
      />
    </>
  );
};

export default DocumentosColaborador;
